import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.assign";
import _regeneratorRuntime from "babel-runtime/regenerator";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from "react";
import { observer } from "mobx-react";
import { get, isNil } from "lodash-es";
import { cx } from "emotion";
import { ControlledEditor } from "@monaco-editor/react";
import { Spinner } from "@reactivepad/blueprint-core";
import { conf, language } from "./language";
import { isFormula, getFormulaHints, getTablesHints } from "../core/utils";
var EDITOR_LANGUAGE = "reactivepad";
var FormulaInput = (_temp2 = _class = function (_Component) {
  _inherits(FormulaInput, _Component);

  function FormulaInput() {
    var _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, FormulaInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.editorDidMount = function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(getEditorValue, monacoInstance) {
        var _this$props, id, store, value, onChange, onSave, monaco, functionsSuggestions;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, id = _this$props.id, store = _this$props.store, value = _this$props.value, onChange = _this$props.onChange, onSave = _this$props.onSave;
                monaco = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.monacoEditorPromise;

              case 5:
                monaco = _context.sent;
                monaco.languages.register({
                  id: EDITOR_LANGUAGE
                });
                monaco.languages.setLanguageConfiguration(EDITOR_LANGUAGE, conf);
                monaco.languages.setMonarchTokensProvider(EDITOR_LANGUAGE, language);
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return");

              case 14:
                onChange(value);
                functionsSuggestions = store.functions.map(function (_ref2) {
                  var name = _ref2.name,
                      description = _ref2.description;
                  return {
                    label: name,
                    kind: monaco.languages.CompletionItemKind.Function,
                    documentation: description,
                    insertText: name
                  };
                });
                _this.completionProvider = monaco.languages.registerCompletionItemProvider(EDITOR_LANGUAGE, {
                  triggerCharacters: ["=", "["],
                  provideCompletionItems: function provideCompletionItems(model, position, context) {
                    var triggerCharacter = context.triggerCharacter;

                    if (!isFormula(model.getValue())) {
                      return;
                    }

                    if (triggerCharacter === "[") {
                      var word = get(model.getWordAtPosition(model.getPositionAt(position.column - 2)), "word");

                      if (!word) {
                        return;
                      }

                      var table = store.findByName(word);
                      var columns = table && table.columns.map(function (_ref3) {
                        var name = _ref3.name;
                        return {
                          label: name,
                          kind: monaco.languages.CompletionItemKind.Text,
                          insertText: name
                        };
                      });
                      return {
                        suggestions: columns
                      };
                    }

                    var storeSuggestions = [].concat(getFormulaHints(store.formulas, id), getTablesHints(store.tables)).map(function (_ref4) {
                      var name = _ref4.name,
                          description = _ref4.description;
                      return {
                        label: name,
                        kind: monaco.languages.CompletionItemKind.Text,
                        insertText: name,
                        detail: description
                      };
                    });
                    var suggestions = [].concat(storeSuggestions, functionsSuggestions);
                    return {
                      suggestions: suggestions
                    };
                  }
                });
                _this.actionEnterKey = monacoInstance.addAction({
                  id: "actionEnterKey_" + id,
                  label: "Enter key submit",
                  keybindings: [monaco.KeyCode.Enter],
                  keybindingContext: "!suggestWidgetVisible",
                  run: function run() {
                    return onSave();
                  }
                });
                monacoInstance.setPosition({
                  lineNumber: 1,
                  column: ("" + value).length + 1
                });
                monacoInstance.focus();

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 11]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), _this.handleChange = function (e, value) {
      _this.props.onChange(value, e);
    }, _this.handleKeyDown = function (e) {
      e.stopPropagation();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FormulaInput.prototype.componentWillUnmount = function componentWillUnmount() {
    this.completionProvider && this.completionProvider.dispose();
    this.actionEnterKey && this.actionEnterKey.dispose();
  };

  FormulaInput.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        value = _props.value,
        className = _props.className,
        wrapperClassName = _props.wrapperClassName,
        style = _props.style,
        editorProps = _props.editorProps,
        height = _props.height,
        fontSize = _props.fontSize;
    var editorHeight = height - 10;
    var options = {
      lineNumbers: "off",
      highlightActiveIndentGuide: false,
      renderFinalNewline: false,
      renderLineHighlight: "none",
      scrollbar: {
        vertical: "hidden"
      },
      minimap: {
        enabled: false
      },
      overviewRulerBorder: false,
      overviewRulerLanes: 0,
      hideCursorInOverviewRuler: true,
      lineHeight: editorHeight,
      revealHorizontalRightPadding: 0,
      verticalSliderSize: 1,
      verticalScrollbarSize: 3,
      codeLens: false,
      contextmenu: false,
      fontSize: fontSize
    };
    return React.createElement("div", {
      id: id,
      className: cx(className, wrapperClassName),
      style: style,
      onKeyDown: this.handleKeyDown
    }, React.createElement(ControlledEditor, _extends({
      height: editorHeight,
      language: EDITOR_LANGUAGE,
      value: isNil(value) ? "" : "" + value,
      options: options,
      onChange: this.handleChange,
      editorDidMount: this.editorDidMount,
      loading: React.createElement(Spinner, {
        size: 10
      })
    }, editorProps)));
  };

  return FormulaInput;
}(Component), _class.defaultProps = {
  value: "",
  onChange: function onChange() {},
  onSave: function onSave() {},
  height: 35,
  fontSize: 15
}, _temp2);
export default observer(FormulaInput);